import React from "react";
import "./BusinessThreeProduct.scss";

const BusinessThreeProduct = () => {
  return (
    <div className="tool-brand-wrapper">
      <div className="brand-tool-combined-section">
        <h2>Top Tools &amp; Related Categories</h2>

        <div className="brand-tool-row">
          {/* Tools */}
          {[
            {
              name: "Speakers",
              img: "https://encrypted-tbn3.gstatic.com/shopping?q=tbn:ANd9GcTmYd_wguRrYGIqmTBIZDEbTI-xHdQ-AIrshM7Qlc_O581P-fgw64xvITR8JqaEii1kRaoZly04tsWwBjOYGHl0dLYoxqpo_iPK-o6vai4VOMFHLrjy-MrgdQ",
            },
            {
              name: "LED walls",
              img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTT_sjyaEZ7Y9qq1GaDBR6iPNEgSePhGNsAWw&s",
            },
            {
              name: "Projectors",
              img: "https://encrypted-tbn0.gstatic.com/shopping?q=tbn:ANd9GcSdS2406X8Pndt49m7h1DTEdRGyLEXica5LIaOWKawTiniRJXS1KYVI4H6mh3qtTUruVFZUByFX-SR2zvyNPGXfASEDboj-3eDBIGVVI_eOjjzGVEQHD54UFg",
            },
            {
              name: "BrightCast",
              img: "https://www.ooberpad.com/cdn/shop/files/Projection-Screen-Sqauare.jpg?v=1688677903&width=550",
            },
          ].map((tool, index) => (
            <div className="tool-item" key={index}>
              <img src={tool.img} alt={tool.name} />
              <h4>{tool.name}</h4>
              <p>Explore Now</p>
            </div>
          ))}
        </div>
      </div>

      {/* 👇 Product Cards Section 👇 */}
      <div className="product-list-section">
        {[
          {
            img: "https://encrypted-tbn3.gstatic.com/shopping?q=tbn:ANd9GcSdsC0ewYafF37du21ciaXMLfNftF7qRi0zs8FeFF4S70JVh6fB7L60H7VuOuFpSrw7NpfphionkfUIHh1y9-UXGi2yR8v5g7c5zV6hRpwnBjQgYTilixtTfQ",
            desc: "ASUS ZenBeam 360 Projector",
            price: "₹112,289",
            oldPrice: "₹225,640 51% OFF",
          },
          {
            img: "https://encrypted-tbn1.gstatic.com/shopping?q=tbn:ANd9GcSEZHYSW0xLOYUA3k3853cK8m8s6Md5fhUiYyzljqXOM1m8xzcHKqGkkfEDLvb9SWsbeBSuolFb0i6kLdGOHfWSutZjJegP_feACkYGgHU",
            desc: "ViewSonic SonicBlaze Mini",
            price: "₹250,149",
            oldPrice: "₹312,268 34% OFF",
          },
          {
            img: "https://encrypted-tbn3.gstatic.com/shopping?q=tbn:ANd9GcRDXFARrr3M8OV2MMGX5-JC4lnITdEmUyo23KhdIUMTzSBYiUdgubZ0X2YpB24cg7v-3Pv5Q-86-bh80z51LM5Zf3MzOfV4Yp9By8RNm5VvryG9Or5m_2nFNQ",
            desc: "Bose EchoStorm Speaker",
            price: "₹100,349",
            oldPrice: "₹111,999 72% OFF",
          },
          {
            img: "https://encrypted-tbn3.gstatic.com/shopping?q=tbn:ANd9GcTF6m2wFLY_3kEuRUeA1b_Qb4TZO2xujgh1SPvr7IZdXrBi3MqGfaB4w_9hnalC6ypYLHTMsYNtRay-GmVUmRNFMCtmpsv0oW7J46ZC8u-K3GiNfdjAOmc7Kg",
            desc: "Devialet SkyView X1",
            price: "₹120,749",
            oldPrice: "₹150,999 60% OFF",
          },
          {
            img: "https://encrypted-tbn3.gstatic.com/shopping?q=tbn:ANd9GcRxgFFfXkpEo6i7pmh0TTMJ38j8wpSTRJzsftumTaRczW8in7gPTITPpod-v4Kw3HIgkgmDeKF6MaRFRMvHYxcuAhJiUIkcHnGfzx7GyC6x8e1a8CM6NDxA",
            desc: "JBL BoomBeat S9 Speaker",
            price: "₹145,079",
            oldPrice: "₹150,000 73% OFF",
          },
          {
            img: "https://encrypted-tbn0.gstatic.com/shopping?q=tbn:ANd9GcQwwH3vxbq6bqKsHsouAdeCJtTMCo6jn_56LVp1aCiFzZQm0BtZKxwqE9kscM9k0OenCOaDPWShWZzLsk-j9x1C8XffJk1Ly7-ZugVol2z7BnsMnaaJRlN0",
            desc: "BenQ LumoBeam 4K Projector",
            price: "₹112,999",
            oldPrice: "₹140,999 70% OFF",
          },
        ].map((item, index) => (
          <div className="product" key={index}>
            <img src={item.img} alt={`Product ${index + 1}`} />
            <p className="desc">{item.desc}</p>
            <h3 className="price">
              {item.price} <span className="old-price">{item.oldPrice}</span>
            </h3>

            <div className="hover-buttons">
              <button className="cart-btn">🛒</button>
              <button className="buy-btn">BUY NOW</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BusinessThreeProduct;
